import { Grid, Paper, Skeleton, Stack, Typography } from "@mui/material";

const DailyLandingPageExperienceSkeleton = () => {
  return (
    <Stack spacing={3}>
      {/* Top Summary Section */}
      <Paper sx={{ p: 2 }}>
        <Stack spacing={1}>
          <Skeleton variant="text" width="30%" height={30} />
          <Skeleton variant="text" width="50%" />
          <Skeleton variant="text" width="40%" />
          <Skeleton variant="rectangular" width="20%" height={25} />
        </Stack>
      </Paper>

      {/* Three Cards Section */}
      <Grid container>
        {Array.from({ length: 3 }).map((_, idx) => (
          <Grid item xs={12} md={4} key={idx}>
            <Paper sx={{ p: 2, minHeight: 150 }}>
              <Skeleton variant="text" width="50%" height={25} />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={100}
                sx={{ mt: 2 }}
              />
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* Chart Section */}
      <Paper sx={{ p: 2 }}>
        <Typography fontSize={24} mb={2}></Typography>
        <Skeleton variant="rectangular" width="100%" height={300} />
      </Paper>
      <Paper sx={{ p: 2 }}>
        <Typography fontSize={24} mb={2}></Typography>
        <Skeleton variant="rectangular" width="100%" height={100} />
      </Paper>
    </Stack>
  );
};

export default DailyLandingPageExperienceSkeleton;
